"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "q": { "user_id_eq_any": null, "hf_member_id_eq_any": null, "recruitment_id_eq_any": null } });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "q": { "user_id_eq_any": [], "hf_member_id_eq_any": [], "recruitment_id_eq_any": [] } });
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.get("/jtj/queries/hf_member__search_applications", { params });
    }
};
